import { gql } from "@medbillai/graphql-types";

export const createPersonMutation = gql(/* GraphQL */ `
  mutation CreatePerson($input: CreatePersonInput!) {
    createPerson(input: $input) {
      ... on Person_Type {
        id
        givenNames
        familyName
        dateOfBirth
        primary
      }
      ... on FormError {
        message
        fields {
          message
          path
        }
      }
    }
  }
`);

export const updatePersonMutation = gql(/* GraphQL */ `
  mutation UpdatePersonForm($input: UpdatePersonInput!) {
    updatePerson(input: $input) {
      ... on Person_Type {
        id
        givenNames
        familyName
        dateOfBirth
        primary
      }
      ... on FormError {
        message
        fields {
          message
          path
        }
      }
    }
  }
`);

export const checkPersonMatchMutation = gql(/* GraphQL */ `
  mutation CheckPersonMatch($input: CheckPersonMatchInput!) {
    checkPersonMatch(input: $input) {
      ... on Person_Type {
        id
        givenNames
        familyName
        dateOfBirth
        primary
        phoneNumber
        emailAddress
        addresses {
          id
          street
          city
          state
          zip
          primary
        }
      }
      ... on FormError {
        message
        fields {
          message
          path
        }
      }
    }
  }
`);
